import {Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {Http} from '@angular/http';


@Injectable()
export class LoginService {

  constructor(public router: Router, public http: Http) {
  }

  public sendLogout(idd) {
    return this.http.post('/api/login/close', {idd: idd});
  };

  public sendLogoutCabinet(clientId) {
    return this.http.post('/api/loginLc/close', {clientId: clientId});
  };

  logout(): void {
    this.router.navigate(['/login'], {queryParams: {}});
    localStorage.removeItem('data');
    localStorage.removeItem('username');
    localStorage.removeItem('idd');
    localStorage.removeItem('token');
    localStorage.removeItem('clientId');

  }
}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/services/login.service.ts